var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScholarHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/ScholarHat",
    clipPath: "url(#clip0_4741_17147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 58",
    d: "M16.79 2.79566C17.2474 2.62199 17.7526 2.62199 18.21 2.79566L32.2589 8.13025C33.9789 8.78338 33.9789 11.2166 32.2589 11.8697L18.21 17.2043C17.7526 17.378 17.2474 17.378 16.79 17.2043L2.7411 11.8697C1.02106 11.2166 1.02106 8.78338 2.7411 8.13025L16.79 2.79566Z",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 97",
    d: "M25.7905 14.1446V18.8814C25.7905 21.1705 21.8141 23.0262 16.9089 23.0262C12.0038 23.0262 8.02734 21.1705 8.02734 18.8814V13.5525",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M3.47266 21.25C3.47266 21.8023 3.92037 22.25 4.47266 22.25C5.02494 22.25 5.47266 21.8023 5.47266 21.25H3.47266ZM3.47266 12.3684V21.25H5.47266V12.3684H3.47266Z",
    fill: "#102D3E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4741_17147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarHat);
export default __webpack_public_path__ + "static/media/ScholarHat.f65e38c0f39058281215dce72d38c4b1.svg";
export { ForwardRef as ReactComponent };